<template>
  <div id="app">
    <router-view/>
    <navigation v-if="$route.meta.navigation != false"></navigation>
  </div>
</template>

<script>
  import Navigation from './components/Navigation.vue';

  export default {
    components: {
      'navigation': Navigation
    },
    created() {
      // this.$store.dispatch('autoLogin');
    }
  }
</script>

<style>
  body {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #app {
    text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
  } 

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  nav.theme--dark.v-toolbar {
    background-color: #1976d2 !important;
  }
</style>